import script from "./uploadPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./uploadPage.vue?vue&type=script&setup=true&lang=ts"

import "./uploadPage.vue?vue&type=style&index=0&id=61ca81b4&scoped=true&lang=scss"
import "./uploadPage.vue?vue&type=style&index=1&id=61ca81b4&scoped=true&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ca81b4"]])

export default __exports__